module.exports = __webpack_public_path__ + "img/icon_map_108_on_101.438bc371.png";